import React from "react";

const ErrorSimple = ({ text, id }) => {
    return (
        <>
            <h3>{text}</h3>
            {id && (
                <div>
                    <strong>[ID {id}]</strong>
                </div>
            )}
        </>
    );
};

export default ErrorSimple;
